import { CustomerModel } from '@cheerfy/lib/reactive/features/api/models/customer/customer.model';
import { ProfileModel } from '@cheerfy/lib/reactive/features/api/models/customer/profile/profile.model';
import { CustomerRepository } from '../../repositories/customer/customer.repository';
import { Cashback } from '../../shared/types/backend/cashback';
import { Authenticable } from './authenticable.interface';

export class Authentication {
    // eslint-disable-next-line
    protected static instance: Authentication | null = null;

    public static getInstance(): Authentication {
        if (Authentication.instance === null) {
            Authentication.instance = new Authentication();
        }

        return Authentication.instance;
    }

    private _customerRepository: CustomerRepository;

    private _auhtenticables: Authenticable[] = [];

    private _currentCustomerProfile: ProfileModel | null = null;

    private _currentCashback: Cashback | null = null;

    private _currentToken: string | null = null;

    protected constructor() {
        this._customerRepository = new CustomerRepository();
    }

    private _handleCustomerChange(customer: ProfileModel | null, token: string | null) {
        const previousCustomer = this._currentCustomerProfile;

        this._currentCustomerProfile = customer;
        this._currentToken = token;

        if (previousCustomer === null && customer !== null) {
            this._handleLogin();
        }

        if (previousCustomer !== null && customer === null) {
            this._handleLogout();
        }
    }

    private async _handleLogin() {
        this._auhtenticables.forEach((a) => a.onLogin(this._currentCustomerProfile!, this._currentCashback));
    }

    private async _handleLogout() {
        this._currentCashback = null;
        this._currentCashback = null;
        this._currentToken = null;

        this._auhtenticables.forEach((a) => a.onLogout());
    }

    public staticHydrate(customerProfile: ProfileModel, cashback: Cashback | null) {
        this._currentCashback = cashback;

        this._handleCustomerChange(customerProfile, null);
    }

    public handleCustomerAuth(customer: CustomerModel | null, token: string | null) {
        this._handleCustomerChange(customer?.profile ?? null, token);
    }

    public register(authenticable: Authenticable) {
        this._auhtenticables.push(authenticable);
    }

    public getCurrentCustomerProfile() {
        return this._currentCustomerProfile;
    }

    public getCurrentToken() {
        return this._currentToken;
    }
}
